import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./components/Menu.css";

import { Container, Card, Row, Col } from "react-bootstrap";
import { FaRegClock } from "react-icons/fa";
import { SiGooglemaps } from "react-icons/si";
import { LuPartyPopper } from "react-icons/lu";
import Confetti from "react-confetti";
import { useWindowSize } from "@uidotdev/usehooks";
import { DessertMenu } from "./components/DessertMenu";
import { PizzaMenu } from "./components/PizzaMenu";
import { CocktailMenu } from "./components/CocktailMenu";

export function Program() {
  const { width, height } = useWindowSize();
  return (
    <Container className="py-5">
      <div className="confetti">
        <Confetti width={width} height={height} />
      </div>

      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="bg-light p-5 shadow-sm rounded text-center">
            <h2 className="mb-4">
              <LuPartyPopper className="text-danger me-2" />
              Party Programm! <LuPartyPopper className="text-danger ms-2" />
            </h2>
            <p>
              Für alle die Lust haben: Kommt mit zum Weltrekordversuch für das
              größte lebendige Windrad der Welt! 🌬️
              <br />
              Wir treffen uns dafür um <FaRegClock className="me-1" />
              <strong>14 Uhr</strong> bei uns zu Hause (Hildrizhauer Str. 24,
              71083 Herrenberg){" "}
              <a
                href="https://g.co/kgs/hkwTQCo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiGooglemaps className="me-1" />
              </a>{" "}
              und gehen von dort gemeinsam zum Event.
              <br />
              <a
                href="https://www.rueckenwind-herrenberg.de/groesstes-lebendiges-windrad-der-welt/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mehr Infos zum Weltrekordversuch gibt's hier!
              </a>
            </p>
            <hr />
            <p>
              Für alle anderen gehts um <FaRegClock className="me-1" />
              <strong>16 Uhr</strong> bei uns zu Hause los
              <br />
              Wir freuen uns auf euch! 🕺💃
            </p>
          </Card>
        </Col>
      </Row>

      <Row className="mt-5 justify-content-center">
        <Col md={4}>
          <PizzaMenu />
        </Col>
        <Col md={4}>
          <CocktailMenu />
        </Col>
        <Col md={4}>
          <DessertMenu />
        </Col>
      </Row>
    </Container>
  );
}

export default Program;
